import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const Pricingmain = ({
  isAtTop,
  imgrad,
  selectedValue,
  handleChangeGetDetails,
  areas,
  proceedtonext,
  weekOptions,
  selectedWeek,
  pricselectedMonth,
  handleChangeMonth,
  availableSonographyOptions,
  selectedSonography,
  handleSonographyChange,
}) => {
  const [isSonographyDropdownOpen, setIsSonographyDropdownOpen] = useState(false);
  const sonographyDropdownRef = useRef(null);
  const sectionThreeRowRef = useRef(null);
  const sectionThreeAutoIndexRef = useRef(0);

  const sectionThreeCards = [
    {
      icon: "/PricingmainS3C1.png",
      title: "A Team That Cares, Not Just a Clinic That Treats",
      description:
        "You get a dedicated team of 9 experts including gynaecologists, dietitians, mental health experts, yoga instructors, and more who collaborate on your care.",
    },
    {
      icon: "/PricingmainS3C2.png",
      title: "A Proactive Plan, Not a Reactive Cycle",
      description:
        "Your entire 9-month journey is pre-planned, so you always know what comes next. Every test, milestone, and care step is guided through one clear system.",
    },
    {
      icon: "/PricingmainS3C3.png",
      title: "Daily Health Tracking, Not Just Monthly Visits",
      description:
        "Our team tracks your vitals and day-to-day health through a smart platform, helping spot concerns early and keeping the focus on prevention.",
    },
    {
      icon: "/PricingmainS3C4.png",
      title: "A Pregnancy Journey That Feels Cherished",
      description:
        "We believe pregnancy is not just a medical condition to manage. It is a 270-day journey of creation that deserves support, celebration, and peace of mind.",
    },
  ];

  const sectionFourRows = [
    { feature: "Expert Consultation", myprega: true, traditional: true },
    { feature: "Dating Sonography", myprega: true, traditional: true },
    { feature: "Zero Wait Time", myprega: true, traditional: false },
    { feature: "24/7 Support", myprega: true, traditional: false },
    { feature: "Digital Health Records", myprega: true, traditional: false },
  ];

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sonographyDropdownRef.current &&
        !sonographyDropdownRef.current.contains(event.target)
      ) {
        setIsSonographyDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    setIsSonographyDropdownOpen(false);
  }, [selectedWeek]);

  useEffect(() => {
    const node = sectionThreeRowRef.current;
    let isPaused = false;

    if (!node) {
      return undefined;
    }

    const autoSlide = () => {
      const cards = Array.from(
        node.querySelectorAll(".pricing-main-section-three__card")
      );

      if (isPaused || window.innerWidth >= 768 || cards.length === 0) {
        return;
      }

      sectionThreeAutoIndexRef.current =
        (sectionThreeAutoIndexRef.current + 1) % cards.length;

      node.scrollTo({
        left: cards[sectionThreeAutoIndexRef.current].offsetLeft,
        behavior: "smooth",
      });
    };

    const pauseSlider = () => {
      isPaused = true;
    };

    const resumeSlider = () => {
      isPaused = false;
    };

    node.addEventListener("touchstart", pauseSlider, { passive: true });
    node.addEventListener("touchend", resumeSlider);
    node.addEventListener("touchcancel", resumeSlider);
    node.addEventListener("pointerdown", pauseSlider);
    node.addEventListener("pointerup", resumeSlider);
    node.addEventListener("pointercancel", resumeSlider);

    const intervalId = window.setInterval(autoSlide, 2200);

    return () => {
      window.clearInterval(intervalId);
      node.removeEventListener("touchstart", pauseSlider);
      node.removeEventListener("touchend", resumeSlider);
      node.removeEventListener("touchcancel", resumeSlider);
      node.removeEventListener("pointerdown", pauseSlider);
      node.removeEventListener("pointerup", resumeSlider);
      node.removeEventListener("pointercancel", resumeSlider);
    };
  }, []);

  const selectedSonographyLabels = availableSonographyOptions
    ?.filter((item) => selectedSonography.includes(String(item.id)))
    .map((item) => item.name);

  return (
    <>
      <div className="pricing-main-page">
        <div>
          <div className="pricing-main-hero">
            <div className="pricing-main-hero__glow pricing-main-hero__glow--left"></div>
            <div className="pricing-main-hero__glow pricing-main-hero__glow--right"></div>
            <div className="pricing-main-hero__inner">
              <div className="pricing-main-hero__content">
                <h1 className="pricing-main-hero__title">
                  The Complete Pregnancy Care You Deserve At a Price You Can
                  Trust
                </h1>
                <p className="pricing-main-hero__description">
                  Every pregnant woman in India spends ₹70,000 or more during
                  her 9-month journey. The problem? It happens in dozens of
                  small, untracked payments, leaving you feeling like you are
                  managing it all alone.
                </p>
                <p className="pricing-main-hero__description">
                  At Myprega, we believe you deserve more than just random tests
                  and rushed visits. You deserve a clear plan, a dedicated team,
                  and complete peace of mind, every single day. That&apos;s why
                  we created India&apos;s only all-in-one, technology-powered
                  pregnancy package at a price that will surprise you.
                </p>
              </div>

              <div className="pricing-main-hero__visual-wrap">
                <img
                  src="/PricingmainH.png"
                  alt="Complete pregnancy care"
                  className="pricing-main-hero__visual"
                />
                <div className="pricing-main-hero__badge">
                  <span className="pricing-main-hero__badge-icon">❤</span>
                  <p className="pricing-main-hero__badge-text">
                    With Myprega, you get full care + full support for the same
                    cost (or even less).
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* New time line section */}
          {/* <div> */}
          <div className="container pricing-main-content">
            <div className="row">
              <div className="col-md-12">
                <div className="pricing-main-section-two">
                  <div className="pricing-main-section-two__content">
                    <h2 className="pricing-main-section-two__title">
                      The ₹70,000 Question: Do You Know What You&apos;re Really
                      Paying For?
                    </h2>
                    <p className="pricing-main-section-two__description">
                      We&apos;ve spoken to over 300 expecting mothers. They go to
                      the best clinics, but they all share a similar feeling:
                      their care is broken. It&apos;s a confusing puzzle of
                      appointments, tests, and payments that they have to piece
                      together themselves.
                    </p>
                    <p className="pricing-main-section-two__description">
                      Pregnancy isn&apos;t just about checkups and scans. It&apos;s
                      also about daily wellbeing, your mental health, nutrition,
                      movement, and that peace of mind that everything is being
                      looked after.
                    </p>
                    <p className="pricing-main-section-two__intro">
                      Does this sound familiar?
                    </p>

                    <div className="pricing-main-section-two__visual-wrap pricing-main-section-two__visual-wrap--mobile">
                      <img
                        src="/PricingmainS2H532445456.png"
                        alt="Pregnancy care concerns illustration"
                        className="pricing-main-section-two__visual"
                      />
                    </div>

                    <div className="pricing-main-section-two__list">
                      <div className="pricing-main-section-two__card">
                        <span className="pricing-main-section-two__icon">♡</span>
                        <div>
                          <h3 className="pricing-main-section-two__card-title">
                            Confusion &amp; Doubt
                          </h3>
                          <p className="pricing-main-section-two__card-text">
                            Am I doing the right test? Did I forget to ask the
                            doctor something important?
                          </p>
                        </div>
                      </div>

                      <div className="pricing-main-section-two__card">
                        <span className="pricing-main-section-two__icon">◫</span>
                        <div>
                          <h3 className="pricing-main-section-two__card-title">
                            The Management Burden
                          </h3>
                          <p className="pricing-main-section-two__card-text">
                            Feeling like you are your own project manager,
                            juggling reports, appointments, and advice from
                            everyone.
                          </p>
                        </div>
                      </div>

                      <div className="pricing-main-section-two__card">
                        <span className="pricing-main-section-two__icon">☰</span>
                        <div>
                          <h3 className="pricing-main-section-two__card-title">
                            Late-Night Googling
                          </h3>
                          <p className="pricing-main-section-two__card-text">
                            Relying on the internet for urgent questions,
                            leading to more anxiety, not less.
                          </p>
                        </div>
                      </div>

                      <div className="pricing-main-section-two__card">
                        <span className="pricing-main-section-two__icon">▣</span>
                        <div>
                          <h3 className="pricing-main-section-two__card-title">
                            Financial Surprises
                          </h3>
                          <p className="pricing-main-section-two__card-text">
                            You pay per visit, per scan, per test. The costs add
                            up, but there&apos;s no clear budget or plan. You
                            never see the total amount in one place.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="pricing-main-section-two__visual-wrap pricing-main-section-two__visual-wrap--desktop">
                    <img
                      src="/PricingmainS2H532445456.png"
                      alt="Pregnancy care concerns illustration"
                      className="pricing-main-section-two__visual"
                    />
                  </div>
                </div>
                <div className="pricing-main-section-three">
                  <div className="pricing-main-section-three__overlay"></div>
                  <div className="pricing-main-section-three__content">
                    <div className="pricing-main-section-three__header">
                      <h2 className="pricing-main-section-three__title">
                        We Knew There Had to Be a Better Way
                      </h2>
                      <p className="pricing-main-section-three__description">
                        That&apos;s exactly why we created Myprega. It&apos;s not
                        just an alternative to a hospital. It&apos;s a complete
                        care system built around you, your baby, and your peace
                        of mind.
                      </p>
                      <p className="pricing-main-section-three__description">
                        We take the broken pieces of traditional care and unite
                        them into one seamless, supportive experience powered by
                        empathy, doctors, and technology.
                      </p>
                    </div>

                    <div
                      className="pricing-main-section-three__cards"
                      ref={sectionThreeRowRef}
                    >
                      {sectionThreeCards.map((card) => (
                        <article
                          key={card.title}
                          className="pricing-main-section-three__card"
                        >
                          <div className="pricing-main-section-three__card-top">
                            <img
                              src={card.icon}
                              alt=""
                              className="pricing-main-section-three__card-icon"
                            />
                          </div>
                          <h3 className="pricing-main-section-three__card-title">
                            {card.title}
                          </h3>
                          <p className="pricing-main-section-three__card-text">
                            {card.description}
                          </p>
                        </article>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="pricing-main-section-four">
                  <div className="pricing-main-section-four__header">
                    <h2 className="pricing-main-section-four__title">
                      See the Difference for Yourself
                    </h2>
                    <p className="pricing-main-section-four__description">
                      Don&apos;t just take our word for it. Here&apos;s a clear
                      comparison of what you get in a typical pregnancy journey
                      versus the Myprega Cherish Care Package.
                    </p>
                  </div>

                  <div className="pricing-main-section-four__table-wrap">
                    <div className="pricing-main-section-four__table">
                      <div className="pricing-main-section-four__row pricing-main-section-four__row--head">
                        <div className="pricing-main-section-four__cell pricing-main-section-four__cell--feature">
                          Features
                        </div>
                        <div className="pricing-main-section-four__cell pricing-main-section-four__cell--brand">
                          Myprega
                        </div>
                        <div className="pricing-main-section-four__cell">
                          Traditional Clinics
                        </div>
                      </div>

                      {sectionFourRows.map((row) => (
                        <div
                          key={row.feature}
                          className="pricing-main-section-four__row"
                        >
                          <div className="pricing-main-section-four__cell pricing-main-section-four__cell--feature">
                            {row.feature}
                          </div>
                          <div className="pricing-main-section-four__cell">
                            <span className="pricing-main-section-four__status pricing-main-section-four__status--yes">
                              {row.myprega ? "✓" : "✕"}
                            </span>
                          </div>
                          <div className="pricing-main-section-four__cell">
                            <span
                              className={`pricing-main-section-four__status ${
                                row.traditional
                                  ? "pricing-main-section-four__status--yes"
                                  : "pricing-main-section-four__status--no"
                              }`}
                            >
                              {row.traditional ? "✓" : "✕"}
                            </span>
                          </div>
                        </div>
                      ))}

                      <div className="pricing-main-section-four__row pricing-main-section-four__row--price">
                        <div className="pricing-main-section-four__cell pricing-main-section-four__cell--feature">
                          Package Price
                        </div>
                        <div className="pricing-main-section-four__cell">
                          <div className="pricing-main-section-four__price pricing-main-section-four__price--brand">
                            ₹1,599
                          </div>
                          <div className="pricing-main-section-four__subtext">
                            60% OFF
                          </div>
                        </div>
                        <div className="pricing-main-section-four__cell">
                          <div className="pricing-main-section-four__price">
                            ₹4,000+
                          </div>
                          <div className="pricing-main-section-four__subtext">
                            Typical cost
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pricing-main-section-five">
                  <div className="pricing-main-section-five__content">
                    <h2 className="pricing-main-section-five__title">
                      Your Complete 9-Month Pregnancy Journey for Less Than
                      What Most Moms Pay for Just Basic Care
                    </h2>
                    <p className="pricing-main-section-five__description">
                      The Myprega Cherish Care Package includes everything
                      mentioned above, with a single, transparent investment in
                      your and your baby&apos;s health.
                    </p>
                    <p className="pricing-main-section-five__description">
                      Feeling overwhelmed by the number? We understand.
                      <br/>
                      That&apos;s why we&apos;ve made it easier than ever to get
                      the care you deserve. Easy Monthly Instalments (EMI) Start
                      your complete care journey for just ₹7,780 / month (For 10
                      Months). (Options for 3, 6, and 9-month EMIs available
                      with most major banks)
                    </p>
                  </div>

                  <div className="pricing-main-section-five__visual-wrap">
                    <img
                      src="/PricingmainS5H.png"
                      alt="Pregnancy package illustration"
                      className="pricing-main-section-five__visual"
                    />
                    <div className="pricing-main-section-five__price-card">
                      <div className="pricing-main-section-five__price">
                        ₹69,999
                      </div>
                      <p className="pricing-main-section-five__price-text">
                        All Inclusive for 10 Months Everything included. No
                        hidden charges. No surprises.
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div className="timeline">
                  <div className="timeline-line"></div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div className="container01 left-container01">
                      <img src="/timeline.png" alt="Timeline"></img>
                      <div className="text-box">
                        <h2 className="hero_subtitle">
                          The million-dollar question – How are we affordable
                          yet promise the best prenatal care?
                        </h2>
                        <p className="bold-font">
                          We aim to provide technology-driven and standardized
                          pregnancy care solutions to everyone without pursuing
                          huge profits. Yes, there are costs involved, and we
                          also need money to sustain the model, but we believe
                          that if a major technological breakthrough is not
                          shared with everyone, then what’s the use for it?
                        </p>
                        <p className="bold-font">
                          It’s as honest as a company can get.
                        </p>
                        <h3 className="second-title ">
                          Now, let’s talk numbers
                        </h3>
                      </div>
                    </div>

                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline01.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline02.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                    <div className="container01 right-container01">
                      <img src="/timeline.png"></img>
                      <div className="text-box">
                        <h2 className="hero_subtitle">
                          We claim to help you save up to ₹100,000 every
                          pregnancy. How?
                        </h2>
                        <p className="bold-font">
                          There’s a set expenditure involved in every step of
                          prenatal care. Doctor’s consultaons, lab tests,
                          sonography, regular visits to the hospital which may
                          be far from your residence, regular check-ups for
                          health care concerns arising due to pregnancy such as
                          Gestaonal Diabetes or Hypertensive Disorder, and not
                          to menon unplanned C-Secons, NICU stays, consultancy,
                          and monitoring charges{" "}
                        </p>
                        <p className="bold-font mt-2 mb-5">
                          {" "}
                          All this not only becomes fairly expensive for parents
                          but overwhelming too.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div className="container01 left-container01">
                      <img src="/timeline.png"></img>
                      <div className="text-box">
                        <h2 className="hero_subtitle">How MyPrega Helps?</h2>
                        <p className="bold-font">
                          You just need to select one of our prenatal packages
                          and you are done. No frequent travel is needed and we
                          even choose the best doctor for you in your locaon for
                          your convenience.{" "}
                        </p>
                        <h3 className="second-title ">There’s more!</h3>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline03.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "-100px",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        maxWidth: "50%",
                        height: "auto",
                        backgroundImage: "url('/timeline04.png')",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        aspectRatio: "1 / 1",
                      }}
                    />
                    <div className="container01 mobile-maging right-container01">
                      <img src="/timeline.png"></img>
                      <div className="text-box ">
                        <h2 className="hero_subtitle">
                          Indirect savings with MyPrega?
                        </h2>
                        <ul className="expensive-ul">
                          <li>
                            <img
                              src="/tick.png"
                              alt="tick"
                              className="tick-expensive"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            Our pregnancy care model focuses on prevention
                            rather than treatment, so our experts try to reduce
                            the chances of health complications, increasing your
                            chances of having a normal delivery.
                          </li>

                          <li>
                            <img
                              src="/tick.png"
                              alt="tick"
                              className="tick-expensive"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            You don’t even need to go anywhere for any kind of
                            consultaon, be it diet, yoga, meditaon, Garbha
                            Sanskar, or pregnancy educaon – our experts take
                            care of it all from the comfort of your home.
                          </li>
                          <li>
                            <img
                              src="/tick.png"
                              alt="tick"
                              className="tick-expensive"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                            No mental pressure due to unplanned C-Secon and
                            prolonged NICU stay.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="pricing-main-section-six">
            <img
              src="/PackagedL.png"
              alt=""
              className="pricing-main-section-six__corner pricing-main-section-six__corner--left"
            />
            <img
              src="/PackagedR.png"
              alt=""
              className="pricing-main-section-six__corner pricing-main-section-six__corner--right"
            />
            <div className="pricing-main-section-six__inner">
              <div>
                <h2
                  className="hero-title text-center pricing-main-section-six__title"
                >
                  Ready to Experience a Better Pregnancy Journey?
                </h2>
              </div>
              {/* </div> */}

              <div className="text-center">
                <h4
                  className="mb-2 fw-bold text-center pricing-main-section-six__subtitle"
                  style={{ fontSize: "22px" }}
                >
                  Have you ever heard of such an effective prenatal care model
                  before? We hadn&apos;t either and that&apos;s exactly how
                  MyPrega was born.
                </h4>
              </div>
              <div className="pricing-main-section-six__card">
                <div className="pricing-main-section-six__dropdowns">
                  <div className="pricing-main-section-six__field-label">
                    Your City
                  </div>
                  <div className="pricing-main-section-six__field">
                    <span className="pricing-main-section-six__field-icon">
                      &#9906;
                    </span>
                    <form className="pricing-main-section-six__form">
                      <select
                        name="subject"
                        id="subject"
                        className="custom-select pricing-main-section-six__select"
                        value={selectedValue}
                        onChange={handleChangeGetDetails}
                      >
                        <option value="">Select your city</option>
                        {areas?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </form>
                  </div>
                </div>
                <div className="pricing-main-section-six__dropdowns">
                  <div className="pricing-main-section-six__field-label">
                    Pregnancy Week
                  </div>
                  <div className="pricing-main-section-six__field">
                    <span className="pricing-main-section-six__field-icon">
                      &#128197;
                    </span>
                    <form className="pricing-main-section-six__form">
                      <select
                        name="month"
                        id="month"
                        className="custom-select pricing-main-section-six__select"
                        value={selectedWeek}
                        onChange={handleChangeMonth}
                      >
                        <option value="">Select pregnancy week</option>
                        {weekOptions?.map((item) => (
                          <option key={item.week} value={item.week}>
                            Week {item.week}
                          </option>
                        ))}
                      </select>
                    </form>
                  </div>
                </div>
                {selectedWeek && (
                  <div className="pricing-main-section-six__dropdowns">
                    <div className="pricing-main-section-six__field-label">
                      Select Tests
                    </div>
                    <div
                      className="pricing-main-section-six__sonography"
                      ref={sonographyDropdownRef}
                    >
                      <button
                        type="button"
                        className="pricing-main-section-six__sonography-trigger"
                        onClick={() =>
                          setIsSonographyDropdownOpen((prevState) => !prevState)
                        }
                      >
                        <span className="pricing-main-section-six__sonography-value">
                          {selectedSonography.length > 0
                            ? "Choose tests"
                            : "Choose tests"}
                        </span>
                        <span className="pricing-main-section-six__chevron">
                          &#709;
                        </span>
                      </button>
                      {selectedSonographyLabels?.length > 0 && (
                        <div className="pricing-main-section-six__tags">
                          {selectedSonographyLabels.map((label) => (
                            <span
                              key={label}
                              className="pricing-main-section-six__tag"
                            >
                              {label} <span aria-hidden="true">×</span>
                            </span>
                          ))}
                        </div>
                      )}
                      {isSonographyDropdownOpen && (
                        <div className="pricing-main-section-six__sonography-menu">
                          {availableSonographyOptions?.map((item) => (
                            <label
                              key={item.id}
                              className="pricing-main-section-six__sonography-option"
                            >
                              <input
                                type="checkbox"
                                value={item.id}
                                checked={selectedSonography.includes(String(item.id))}
                                onChange={handleSonographyChange}
                              />
                              <span>{item.name}</span>
                            </label>
                          ))}
                          <div className="pricing-main-section-six__sonography-actions">
                            <button
                              type="button"
                              className="pricing-main-section-six__menu-done"
                              onClick={() => setIsSonographyDropdownOpen(false)}
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="pricing-main-section-six__action">
                  <div className="buy pricing-main-section-six__button-wrap">
                    <Link
                      href="#"
                      className="text-white pricing-main-section-six__button-link"
                      onClick={() => proceedtonext()}
                    >
                      PROCEED
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricingmain;
